import React from "react";
import styled from "styled-components";

const Container = styled.div`
  min-height: 85vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  background: ${({ theme }) => theme.homeBg};
`;

const Title = styled.h1`
  font-size: 2.2rem;
  font-weight: bold;
  margin-bottom: 20px;
  color: ${({ theme }) => theme.welcomeText};
  text-align: center;
`;

const Subtitle = styled.h2`
  font-size: 1.5rem;
  font-weight: bold;
  margin: 20px 0 10px 0;
  color: ${({ theme }) => theme.headerText};
  text-align: left;
  width: 100%;
  max-width: 900px;
`;

const Paragraph = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  color: ${({ theme }) => theme.headerText};
  margin-bottom: 16px;
  max-width: 900px;
  text-align: left;
`;

const List = styled.ol`
  max-width: 900px;
  text-align: left;
  margin-left: 20px;
  margin-bottom: 20px;
  color: ${({ theme }) => theme.headerText};
  line-height: 1.6;
`;

const ListItem = styled.li`
  margin-bottom: 12px;
`;

export default function RonsRants() {
  return (
    <Container>
      <Title>Ron’s Rants</Title>

      <Subtitle>Context</Subtitle>

      <Paragraph>
        Here are my two cents worth of ideas and an opinion. The main focus for
        all data in all of the workbooks for all years for the beef cattle project
        has been one rule:
      </Paragraph>
      <Paragraph>
        <strong>
          Make sure the data which is in the spreadsheets is exactly the same
          when I upload it into the CSB final production database.
        </strong>
      </Paragraph>

      <Paragraph>
        The rule seems clear enough, but doesn't always work out this way. Below are some examples:
      </Paragraph>

      <List>
        <ListItem>
          All previous years of data in the database are calculated the way the
          vet determined was best. For the last 5 years, those total head days
          were acceptable. By introducing a new calculation method, we now have
          inconsistent data in the database.
        </ListItem>
        <ListItem>
          There are fundamental sources of data. From those, we can derive other
          variables. Total head days is based on # of animals in and # of days
          on feed. This is a derived variable from more fundamental sources.
        </ListItem>
        <ListItem>
          Reporting time is when we derive other variables of importance, such
          as total head days or animals at risk. Fundamental variables include
          # of animals in, # railed, and # died. For example, animals slaughtered
          is derived from (# in - # railed - # died).
        </ListItem>
        <ListItem>
          At report generation time, we calculate derived variables. We can
          create as many as we want, as long as the fundamental data is correct.
        </ListItem>
        <ListItem>
          Storing derived variables is not a problem. But when multiple
          definitions exist, reporting is the place to generate and
          provide different calculated variables.
        </ListItem>
        <ListItem>
          Who is responsible for derived variables? At report time, I create all
          versions as requested. But ideally, data scientists should derive
          their variables using analytical tools, instead of us creating
          endless variations in the database.
        </ListItem>
      </List>
    </Container>
  );
}
